import { render, staticRenderFns } from "./Profissionalizacao.vue?vue&type=template&id=3cf7ee58"
import script from "./Profissionalizacao.vue?vue&type=script&lang=js"
export * from "./Profissionalizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports